export default __webpack_public_path__ + "static/media/spa.c7035be8.png";